import styled from "styled-components";

export const ReportCatalogWrapper = styled.div`
    height: 100%;
    background-color: var(--theme-color-secondary);
    /* border: 1px solid var(--border-color-secondary); // should remove later */
    /* display: flex; */
    /* gap: 20px; */
    overflow: hidden;
    /* background-color: red; */
    /* padding: 4px; */
`;

export const ReportCatalogContainer = styled.div`
    position: relative;
    height: 100%;
    /* background-color: var(--theme-color-secondary); */
    /* border: 1px solid var(--border-color-secondary); */
    display: flex;
    /* gap: 20px; */
    overflow: hidden;
`;

export const ReportCatalogMainEmpty = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const ReportCatalogMain = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    /* height: calc(100vh - 90px); */
    background-color: var(--theme-color-secondary);
    border-left: 1px solid var(--border-color-secondary);
    overflow: hidden;
    transition: all ease-in-out 0.3s;

    @media only screen and (max-width: 900px) {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: ${({ $selectModule }) => ($selectModule ? '0' : '100%')};
        opacity: ${({ $selectModule }) => ($selectModule ? 1 : 0)};
        border-left: none;
    }
`;

export const ReportCatalogMainHead = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 35.6px 20px;

    svg {
        display: none;
        width: 12px;
        height: auto;
        opacity: 0.4;
        transition: all ease-in-out 0.3s;
        cursor: pointer;

        &:hover {
            opacity: 0.6;
            transform: rotate(90deg);
        }

        @media only screen and (max-width: 900px) {
            display: block;
        }
    }
`;

// export const ReportCatalogMainBody = styled.div`
//     /* height: 100%; */
//     /* display: flex; */
//     /* background-color: red; */
//     border-top: 1px solid var(--border-color-secondary);
//     padding: 20px;
//     /* overflow: auto; */
// `;

export const ReportCatalogFiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    /* background-color: yellow; */
`;

export const ReportCatalogFiltersHead = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
`;

export const ReportCatalogFormats = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;

    div {
        background-color: var(--table-border-color);
        color: var(--text-color-primary);
        text-transform: uppercase;
        font-size: 14px;
        padding: 4px 8px;
        border-radius: 5px;
        cursor: pointer;
        /* transition: all 0.3s ease-in-out; */

        &.active {
            color: var(--theme-color-primary);
            background-color: var(--theme-color-primary-light);
        }
    }
`;

export const ActionsContainer = styled.div`
    /* background-color: red; */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 10px;
`;

export const HistoryDownloadButton = styled.div`
    color: var(--theme-color-primary);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 5px 0;
    cursor: pointer;

    span {
        color: var(--theme-color-primary);
    }

    svg {
        width: 16px;
        height: auto;
    }
`;

export const TableWrapper = styled.div`
    height: 100%;
    /* background-color: red; */
    display: flex;
    flex-direction: column;
    /* width: 100%;
    height: 100%;
    background-color: red; */
    /* padding: 14px; */
    /* border-radius: 1rem; */
    /* background-color: var(--theme-color-tertiary); */
    /* border: 1px solid var(--table-border-color); */
    /* display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; */
    /* padding: 20px; */
    /* overflow: hidden; */
`;

export const TableContainer = styled.div`
    flex: 1;
    background-color: green;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    overflow: hidden;
`;

export const EmptyWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

export const FormError = styled.p`
    color: var(--color-warning);
    font-size: 11px;
    margin: 0;
    padding-top: 2px;
`;
